import { makeStyles, createStyles, Theme } from '@material-ui/core';
import { BrandColors } from '../../constants';
import { TemplateSettings } from '../../store/interfaces';

export const LanguageDropdownStyles = makeStyles((theme: Theme) =>
  createStyles({
    icon: ({ utilityBar }) => ({
      marginBottom: '3px',
      '& path': {
        fill: utilityBar.textColor,
      },
    }),
    languageList: (props: TemplateSettings) => ({
      backgroundColor: 'inherit',
      color: props.utilityBar.textColor,
      boxShadow: 'none',
      border: 'none',
      width: '100%',
      maxHeight: '200px',
      overflow: 'auto',
      paddingTop: 0,
      paddingBottom: 0,
      marginTop: '4px',
      outline: 'none',
      '& .MuiListItem-root.Mui-selected, .MuiListItem-root.Mui-selected:hover': {
        backgroundColor: BrandColors.blackWithOpacity25,
        fontWeight: '600 !important',
      },
      '& span': {
        color: props.utilityBar.textColor,
      },
      '& .MuiListItem-root': {
        padding: '0.25em 0.5em',
        margin: '0.125em 0',
      },
      '& .MuiListItemText-root': {
        margin: '0',
      },
    }),
    fontSize: {
      '& span': {
        [theme.breakpoints.down('xs')]: {
          fontSize: '14px',
        },
        [theme.breakpoints.up('md')]: {
          fontSize: '16px',
        },
        [theme.breakpoints.up('lg')]: {
          fontSize: '16px',
        },
      },
    },
    listItem: {
      minHeight: '0px !important',
    },
  }),
);
